import { colorPrimary } from "@/constants/colors";
import { useTranslate } from "@/hooks";
import { TextField } from "@mui/material";
import { FC, memo } from "react";
import { TCustomTextField } from "./CustomTextfield.props";
import Hint from "../../HOC/Hint/Hint";

const CustomTextfieldComponent: FC<{ height?: number } & TCustomTextField> = ({ touched, hint = "", height = 33, multiline, minWidth, minRows, sx, ...props }) => {
	const translate = useTranslate();

	return (
		<Hint hint={hint}>
			<TextField
				multiline={multiline}
				minRows={multiline ? minRows ?? 3 : undefined} // дефолт для многострочного
				InputProps={{
					...props.InputProps, // сохраняем существующие стили
					inputProps: {
						...(props.InputProps?.inputProps || {}),
						min: props.min, // прокидываем минимальное значение
					},
					sx: multiline
						? {
								"& textarea": {
									padding: "8px 13px !important",
									fontSize: 13,
									lineHeight: 1.4,
									color: colorPrimary,
								},
								"&.MuiOutlinedInput-root": {
									padding: "8px 13px !important",
								},
								"& legend": {
									fontSize: "10px",
								},
						  }
						: {
								"&.MuiOutlinedInput-root": {
									padding: "8px 13px !important",
								},

								height,
								fontSize: 13,
								color: colorPrimary,
						  },
				}}
				InputLabelProps={{
					style: {
						fontSize: 13,
					},
					shrink: true,
				}}
				error={Boolean(touched && props.error)}
				helperText={touched ? props.helperText : ""}
				FormHelperTextProps={{
					sx: {
						fontSize: 10,
						lineHeight: 1.2,
					},
				}}
				sx={{
					minWidth,
					'.MuiInputLabel-root[data-shrink="false"]': { top: -8 },
					"& .MuiOutlinedInput-input": {
						padding: "0 !important",
					},
					"& .MuiInputBase-input": {
						padding: "0 !important",
					},
					...sx,
				}}
				label={translate(String(props.label ?? ""))}
				{...props}
			/>
		</Hint>
	);
};

// Мемоизация с кастомным сравнением пропсов
export default memo(CustomTextfieldComponent, (prevProps, nextProps) => {
	return (
		prevProps.touched === nextProps.touched &&
		prevProps.error === nextProps.error &&
		prevProps.helperText === nextProps.helperText &&
		prevProps.label === nextProps.label &&
		prevProps.value === nextProps.value
	);
});
